<script>
// import Swiper JS
import Swiper from "swiper";
// import Swiper styles
import "swiper/swiper-bundle.css";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper/core";

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay]);

export default {
  data() {
    return {
      cont: false,
    };
  },
  mounted() {
    var swiper = new Swiper(this.$refs["mySwiper"], {
      slidesPerView: 1,
      spaceBetween: 20,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      pagination: {
        el: this.$refs["swiper-pagination"],
        clickable: true,
      },
      navigation: {
        nextEl: this.$refs["swiper-button-next"],
        prevEl: this.$refs["swiper-button-prev"],
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 90,
        },
      },
    });
  },
};
</script>

<template>
  <section id="testimonial" class="testimonial">
    <div class="container">
      <h2>Confira algumas histórias de quem já participou</h2>
      <div class="swiper-container mySwiper" ref="mySwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="here-card">
              <div class="img">
                <img src="@/assets/images/dpsp/Jonathan.png" alt="" />
              </div>
              <div class="text">
                <h4>“</h4>
                <p>
                  Iniciei minhas atividades no Grupo DPSP em 2017 como Jovem
                  Aprendiz, no CD São Paulo. Tive uma boa experiência na área de
                  Logística, em que também fui efetivado, e hoje estou na matriz
                  como Assistente Comercial, e é muito gratificante quando uma
                  empresa olha para o seu funcionário podendo desenvolvê-lo
                  internamente e gerando ainda mais aprendizado. Feliz em fazer
                  parte do Grupo DPSP.
                </p>
              </div>
              <span>
                <strong class="primary">JONATHAN SOUZA</strong>
                Equipe Financeira
              </span>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="here-card">
              <div class="img">
                <img src="@/assets/images/dpsp/Gabriela.png" alt="" />
              </div>
              <div class="text">
                <h4>“</h4>
                <p>
                  Entrei no Grupo como Analista Pleno na área de Planejamento,
                  Controle e Gestão. Depois de um ano fui promovida nessa mesma
                  área. No ano seguinte, conversando com meus líderes, percebi
                  que precisava de novos desafios, encontrei uma oportunidade e
                  participei de um processo interno para coordenação de Trade
                  Marketing. Hoje, estou nessa cadeira, muito feliz e cheia de
                  projetos em mente.
                </p>
              </div>
              <span>
                <strong> GABRIELA MARRA </strong>
                Equipe Trade Marketing
              </span>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="here-card">
              <div class="img">
                <img src="@/assets/images/dpsp/Victoria.png" alt="" />
              </div>
              <div class="text">
                <h4>“</h4>
                <p>
                  Iniciei no Grupo DPSP através do primeiro programa de Trainee,
                  em 2016. Ao final do programa assumi uma posição de
                  Especialista na área de Operações, onde pude vivenciar de
                  perto toda nossa operação. E por meio de um processo interno,
                  hoje assumi um novo desafio na área de Inovação (Labs) do
                  Grupo. Gosto muito de trabalhar na DPSP por conta dos valores
                  que a empresa carrega e das pessoas, todos são muito
                  receptivos e tornam o ambiente muito colaborativo.
                </p>
              </div>
              <span> <strong> VICTORIA LEITE </strong> Equipe Labs </span>
            </div>
          </div>
        </div>
        <!-- <div class="swiper-pagination" ref="swiper-pagination"></div>
        <div class="swiper-button-prev" ref="swiper-button-prev"></div>
        <div class="swiper-button-next" ref="swiper-button-next"></div> -->
      </div>
    </div>
    <div class="banner">
      <img src="@/assets/images/dpsp/banner-final.jpg" alt="">
    </div>
  </section>
</template>

<style lang="scss" scoped>
.banner {
  margin-top: 3rem;
  img {
    width: 100%;
    height: auto;
  }
    @media all and (min-width: 1400px) {
      margin-top: 7rem;
  }
}
.here-card {
  display: flex;
  padding: 6rem 1rem 1rem 1rem;
  background: #ffffff;
  flex-direction: column;
  box-shadow: 0px 4px 12px 8px rgba(0, 0, 0, 0.06);
  border-radius: 30px;
  border-left: 3rem solid theme-color(yellow-br);
  min-height: 330px;
  justify-content: flex-start;
  @media all and (max-width: 1400px) {
    min-height: 430px;
  }
  @include media-breakpoint-down(sm) {
    padding: 5rem 1rem 2rem 2rem;
  }
  .img {
    width: 80px;
    height: 80px;
    border-radius: 400px;
    border: 1px solid #f7dd69;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    position: absolute;
    top: -2rem;
    left: -1.5rem;
    img {
      height: 100% !important;
      width: auto !important;
      display: block;
      margin: 0 auto;
    }
  }
  .text {
    width: 100%;
    box-sizing: border-box;
    text-align: left;
    position: relative;
    p {
      font-size: 0.9rem;
      line-height: calc(0.9rem * 1.8);
      font-family: "Nunito";
    }
    h4 {
      font-weight: bold;
      font-size: 4rem;
      position: absolute;
      top: -2.5rem;
      color: #f7dd69;
      left: 0.1rem;
      font-family: "Nunito-bold" !important;
    }
  }

  @include media-breakpoint-down(md) {
    min-height: 100px;
    flex-direction: column;

    .text {
      width: 100%;
      box-sizing: border-box;
      p {
        font-size: 1.3rem;
      }
    }
  }

  @include media-breakpoint-down(sm) {
    flex-direction: column;
    .text {
      width: 100%;
      box-sizing: border-box;
      p {
        font-size: 1rem;
      }
    }
  }
}

span {
  font-size: 0.8rem;
  color: #000;
  position: absolute;
  top: 10px;
  left: 80px;
  strong {
    color: theme-color(secondary) !important;
    display: block;
    margin: 0px;
  }
}

.mySwiper {
  width: 100%;
  margin-top: 2rem;
  padding: 2rem 2rem 2rem 2rem;
  margin-bottom: -40px;
  @media screen and (max-width: 1400px) {
    padding: 2rem 0rem 2rem 6rem;
    padding-bottom: 7rem;
  }
  @include media-breakpoint-down(sm) {
    padding: 2rem 0rem 2rem 1rem;
    width: 100%;
    .img {
      width: 70px;
      height: 70px;
      left: -1rem;
    }
    border-width: 2rem;
  }
}

.swiper-wrapper {
  height: auto;
}

.testimonial {
  margin: 6rem 0px;
  h2 {
    color: theme-color(primary);
    text-align: center;
    margin-bottom: 4rem;
  }
  @include media-breakpoint-down(sm) {
    margin: 0rem 0px;
  }
  p {
    font-size: 1.9rem;
    color: #000;
  }

  .swiper-container {
    height: 100%;
  }

  .swiper-slide {
    font-size: 18px;
    position: relative;
  }

  .swiper-slide img {
    display: block;
    object-fit: cover;
  }

  .swiper-slide {
    margin-right: 5rem !important;
    @include media-breakpoint-down(md) {
      margin-right: 4rem !important;
    }
    @include media-breakpoint-down(sm) {
      margin-right: 0rem !important;
      margin-left: 1rem !important;
    }
  }
}
</style>